var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-layout',{style:({maxHeight: 'calc(100vh - 64px)', height: 'calc(100vh - 64px)'})},[(_vm.$store.appName)?_c('a-layout-content',{style:({padding: '12px 16px'})},[_c('div',{staticClass:"center-middle"},[_c('a-icon',{staticClass:"mr-2",attrs:{"type":"loading"}}),_vm._v(" Redirecting... ")],1)]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }